import { WorkflowStatusName, ReceptionReportType, ReceptionDetailListColor, ReceptionListCardStyleDispInfo, } from "../items";
import { Department } from "../../department";
import { ReceptionListDispInfoBase } from "../base";
import { TodoListTabKinds } from "../kinds";

// Todoリスト画面表示用model
export class ReceptionTodoListDispInfo extends ReceptionListDispInfoBase {
  constructor() {
    super();
    this.workflowStatuses = [];
    this.reportTypes = [];
    this.departments = [];
    this.displayColor = null;
  }

  // WFステータスリスト
  public workflowStatuses: WorkflowStatusName[];

  // 初期選択ステータス
  public defaultSelectStatus: WorkflowStatusName;

  // 書類種別リスト
  public reportTypes: ReceptionReportType[];

  // 所属診療科リスト
  public departments: Department[];

  // 背景・文字色
  public displayColor: ReceptionDetailListColor;

  // 下書きタブの有無
  public myDraftTabEnable: boolean;

  // 対応済みタブの有無
  public myWrittenTabEnable: boolean;

  // 文書新規作成ボタン有効フラグ
  public isDocumentCreateButtonEnable: boolean;

  // デフォルトタブ
  public defaultSelectedTodoListTab: TodoListTabKinds;

  // カードスタイル設定
  public cardStyle: ReceptionListCardStyleDispInfo;
}
